import { useState } from 'react';
import { useAdminOrders } from '@/hooks/useAdmin';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { OrdersTable } from '@/components/admin/OrdersTable';
import { StatusFilter } from '@/components/admin/StatusFilter';

const STATUS_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'paid', label: 'Paid' },
  { value: 'queued', label: 'Queued' },
  { value: 'printing', label: 'Printing' },
  { value: 'post_processing', label: 'Post-Process' },
  { value: 'packed', label: 'Packed' },
  { value: 'shipped', label: 'Shipped' },
  { value: 'delivered', label: 'Delivered' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'failed', label: 'Failed' },
];

export const AdminOrdersPage = () => {
  const [statusFilter, setStatusFilter] = useState('');
  const { data, isLoading, error } = useAdminOrders(statusFilter || undefined);

  return (
    <div>
      <div
        className="flex flex-col sm:flex-row sm:items-center justify-between"
        style={{ marginBottom: 'var(--space-6)', gap: 'var(--space-3)' }}
      >
        <h1
          style={{
            fontSize: 'var(--text-2xl)',
            fontWeight: 'var(--font-weight-bold)',
            color: 'var(--text-primary)',
            letterSpacing: 'var(--tracking-tight)',
          }}
        >
          Orders
        </h1>
      </div>

      <div style={{ marginBottom: 'var(--space-4)' }}>
        <StatusFilter
          value={statusFilter}
          onChange={setStatusFilter}
          options={STATUS_OPTIONS}
        />
      </div>

      {isLoading && (
        <div style={{ paddingTop: 'var(--space-12)', paddingBottom: 'var(--space-12)' }}>
          <LoadingSpinner size="lg" />
        </div>
      )}

      {error && (
        <div
          className="text-center"
          style={{
            padding: 'var(--space-8)',
            color: 'var(--color-error-500)',
            fontSize: 'var(--text-sm)',
          }}
        >
          Failed to load orders. Please try again.
        </div>
      )}

      {data && <OrdersTable orders={data.data} />}
    </div>
  );
};
